import ImageConverterTemplate from "../components/ImageConverterTemplate";
export default function ConvertBmpToJpeg() {
  return <ImageConverterTemplate sourceFormat="BMP" targetFormat="JPEG" acceptTypes=".bmp,image/bmp" slug="convert-bmp-to-jpeg" gradientColors="from-amber-500 to-orange-600" accentColor="orange" showQualitySlider={true} />;
}
